import ApiClient from '@softwaredev_cegeka/api-client'

class TranslationsApi extends ApiClient {
    static BASE_URL = '/api/translation'

    /**
     * @param {Object} params
     * @param {Symbol} [cancelId=null] Calls with the same Symbol as an ongoing call will cancel the ongoing call before starting a new one
     * @return {Promise<*>}
     */
    async fetchLanguages(params = {}, cancelId = null) {
        const res = await this.client.get('/languages/', { cancelId })
        const results = res.data.map(item => {
            return {
                language: item.code,
                label: item.name,
            }
        })
        return { data: { results: results } }
    }
}

export default TranslationsApi
